import { useHover as useHoverWeb } from '@react-aria/interactions';
import { useEffect } from 'react';
import { attachEventHandlersOnRef } from '@react-native-aria/utils';
export const useHover = (props, ref) => {
  let params = useHoverWeb(props);
  useEffect(() => {
    attachEventHandlersOnRef(params.hoverProps, ref);
  }, []);
  return params;
};
//# sourceMappingURL=useHover.web.js.map